import { useCallback } from 'react';
import { flatRequestColorsMap } from '../constants/stagesColorMaps';
import { requestFlat } from '../constants/requestFlat';
import useRequestByHouse from './useRequestByHouse';
import { useSelector } from 'react-redux';
import { useGetCountIndicators } from './useGetCountIndicators';

const useColorChess = () => {
  const { requests = [] } = useRequestByHouse();

  const valuesRequestAttributes = useSelector(
    (state) => state.housingStockStore.valuesRequestAttributes
  );

  const getIndicators = useGetCountIndicators();

  const getColorForFlat = useCallback(
    (item) => {
      const flatRequest = requests?.find(
        (request) => request.addressId === item.addressId
      );

      if (!flatRequest) return undefined;

      if (!!valuesRequestAttributes?.length) {
        const { sumDeadline, sumExpired, sumExcess } = getIndicators(
          item.addressId
        );
        const finishType = item?.address?.addressTypeFinishId;

        const hasColor = valuesRequestAttributes?.some((filterValue) => {
          switch (filterValue) {
            case 1:
              return !!sumDeadline;
            case 2:
              return !!sumExpired;
            case 3:
              return !!sumExcess;
            case 4:
              return finishType === 4;
            default:
              return true;
          }
        });

        if (!hasColor) return undefined;
      }

      if (!!flatRequest.sumNew)
        return flatRequestColorsMap.get(requestFlat.NEW_REQUEST);

      if (!!flatRequest.sumProgress)
        return flatRequestColorsMap.get(requestFlat.WORK_REQUEST);

      if (!!flatRequest.sumCompleted)
        return flatRequestColorsMap.get(requestFlat.COMPLETED_REQUEST);

      if (!!flatRequest.sumClosed)
        return flatRequestColorsMap.get(requestFlat.CLOSE_REQUEST);

      return undefined;
    },
    [requests, valuesRequestAttributes?.length, getIndicators]
  );

  return getColorForFlat;
};

export default useColorChess;
